var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var SessionEnrollmentController = {
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/enrollments/filtered" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string | null} userId
        * @param {string | null} sessionId
        * @returns {SessionEnrollmentDownloadDto[]}
    ******************************************************************************************************/
    GetEnrollments: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("userId", JSON.stringify(data.userId));
        fd.append("sessionId", JSON.stringify(data.sessionId));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/enrollments/filtered", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/enrollments/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {SessionEnrollmentDownloadDto}
    ******************************************************************************************************/
    GetEnrollment: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/enrollments/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/enrollments" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SessionEnrollmentUploadDto} dto
        * @returns {SessionEnrollmentDownloadDto}
    ******************************************************************************************************/
    CreateEnrollment: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/enrollments", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/enrollments/{id}" and http method "PUT" to call the back-end.
    
        * @param {string} id
        * @param {SessionEnrollmentUploadDto} dto
        * @returns {SessionEnrollmentDownloadDto}
    ******************************************************************************************************/
    UpdateEnrollment: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/enrollments/{id}", __assign({}, data)),
            method: "PUT",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/enrollments/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteEnrollment: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/enrollments/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=SessionEnrollmentController.js.map